import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconsModule } from "@mk/med-icons";

import { MedPaginationComponent } from "./med-pagination.component";

@NgModule({
  declarations: [
    MedPaginationComponent,
  ],
  imports: [
    CommonModule,
    MedIconsModule,
  ],
  exports: [
    MedPaginationComponent,
  ],
})
export class MedPaginationModule { }
